import { makeVar } from '@apollo/client';

const isOpenListDictInitialValue = false;

export const isOpenListDictVar = makeVar<boolean>(isOpenListDictInitialValue);
